import { render } from "./RequirementEditModal.vue?vue&type=template&id=0145c196&scoped=true"
import script from "./RequirementEditModal.vue?vue&type=script&lang=js"
export * from "./RequirementEditModal.vue?vue&type=script&lang=js"

import "./RequirementEditModal.vue?vue&type=style&index=0&id=0145c196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0145c196"]])

export default __exports__